export default __webpack_public_path__ + "img/ad8468964c5e88d2fde2015a615b2654.png";